import React from 'react';
import Navbar from '../components/Navbar';
import AnimatedBackground from '../components/AnimatedBackground';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import './About.css';

const Capabilities = () => {
  return (
    <div className="about-container">
      <AnimatedBackground />
      <Navbar />

      <section className="capabilities-download about-bg3 about-page-section">
        <div className="capabilities-layout">
          <motion.div
            className="capabilities-content"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <h2>
              <span role="img" aria-label="document">📄</span>
              Discover Our Full Capabilities
            </h2>

            <p>
              Click below to download our Capabilities Statement.
            </p>

            <a
              href="/Sapiencia_Cap_Statement.pdf"
              download
              className="download-button"
            >
              ⬇️ Download Capabilities Statement
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Capabilities;